import { render, staticRenderFns } from "./ClientInvoice.vue?vue&type=template&id=7ece3fde&scoped=true"
import script from "./ClientInvoice.vue?vue&type=script&lang=js"
export * from "./ClientInvoice.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=7ece3fde&prod&scoped=true&lang=css&external"
import style1 from "./ClientInvoice.vue?vue&type=style&index=1&id=7ece3fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ece3fde",
  null
  
)

export default component.exports